import './all-blocks.js';
import './theme.scss';
import registerColors from './shared/color';
import { isEditing } from './shared/utils';
// eslint-disable-next-line
import i18n from './shared/i18n';
if (isEditing()) {
    registerColors();
}
